// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tarjeta flotante: clases base en Header.css (importado desde el .tsx).
   Fondo sólido (la campana usa rgba 0.45 y sobre vídeo se lee fatal). */
.map-global-alert-card__root.header-notifications-dropdown__item {
  margin: 0;
  max-width: min(400px, calc(100vw - 32px));
  background: #1a1a1a !important;
  border: 1px solid #2a2a2a !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.55) !important;
}

.map-global-alert-card__root.header-notifications-dropdown__item:hover {
  background: #252525 !important;
  border-color: #3d3d3d !important;
}

.map-global-alert-card__headline-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.map-global-alert-card__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition:
    color 0.15s,
    background 0.15s;
}

.map-global-alert-card__close:hover {
  color: #f1f5f9;
  background: rgba(255, 255, 255, 0.08);
}

.map-global-alert-card__close:focus-visible {
  outline: 2px solid rgba(166, 27, 52, 0.55);
  outline-offset: 2px;
}

/* Por encima del contenedor de toasts (50000) al gestionar desde el popup global */
.global-alert-manage-modal__backdrop {
  z-index: 50100;
}
`, "",{"version":3,"sources":["webpack://./src/components/GlobalNotificationListener.css"],"names":[],"mappings":"AAAA;wEACwE;AACxE;EACE,SAAS;EACT,yCAAyC;EACzC,8BAA8B;EAC9B,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;EACE,cAAc;AAChB","sourcesContent":["/* Tarjeta flotante: clases base en Header.css (importado desde el .tsx).\n   Fondo sólido (la campana usa rgba 0.45 y sobre vídeo se lee fatal). */\n.map-global-alert-card__root.header-notifications-dropdown__item {\n  margin: 0;\n  max-width: min(400px, calc(100vw - 32px));\n  background: #1a1a1a !important;\n  border: 1px solid #2a2a2a !important;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.55) !important;\n}\n\n.map-global-alert-card__root.header-notifications-dropdown__item:hover {\n  background: #252525 !important;\n  border-color: #3d3d3d !important;\n}\n\n.map-global-alert-card__headline-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.map-global-alert-card__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  margin: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  transition:\n    color 0.15s,\n    background 0.15s;\n}\n\n.map-global-alert-card__close:hover {\n  color: #f1f5f9;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.map-global-alert-card__close:focus-visible {\n  outline: 2px solid rgba(166, 27, 52, 0.55);\n  outline-offset: 2px;\n}\n\n/* Por encima del contenedor de toasts (50000) al gestionar desde el popup global */\n.global-alert-manage-modal__backdrop {\n  z-index: 50100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
